import React from 'react';

export function TriplanSidebarDivider() {
	return <hr className="margin-block-20-10" />;
}

export function TriplanSidebarEqualDivider() {
	return <hr className="margin-block-10" />;
}
